export default __webpack_public_path__ + "static/media/14@2x.b0a8b7de.png";